import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

import { header, headerLink, headerLogo, menuButtonArea, menuButtonItem, menuButton, iconContainer, menuIcon, closeIcon, iconFirstLine, iconSecondLine } from "./header.module.css"

import Menu from "./menu"

class Header extends React.Component {
  constructor(props) {
    super(props)
    this.handleMenuChange = this.handleMenuChange.bind(this)
    this.state = {
      menuOpen: false,
    }
  }

  handleMenuChange(open) {
   this.setState({ menuOpen: open })
  }

  render() {
    return (
      <>
        <header className={header}>
          <Link className={headerLink} to="/">
            <svg className={headerLogo} aria-labelledby="title" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 134.306 12.995"><g transform="translate(-125.881 -217.896)"><path d="M129.106,218.359v9.694h5.087v2.741h-8.312V218.359Z" transform="translate(0 -0.183)" fill="#161615" /><path d="M147.348,218.359v7.364a2.515,2.515,0,0,0,.634,1.92,2.291,2.291,0,0,0,3.02.056,2.721,2.721,0,0,0,.728-2.256v-7.084h3.225V225.5a5.047,5.047,0,0,1-1.4,4.027,5.367,5.367,0,0,1-4.1,1.548,5.553,5.553,0,0,1-4.12-1.491,5.8,5.8,0,0,1-1.212-4.083v-7.141Z" transform="translate(-7.219 -0.183)" fill="#161615" /><path d="M172.054,218.359v12.435h-3.225V218.359Z" transform="translate(-16.997 -0.183)" fill="#161615" /><path d="M181.158,226.882a4.357,4.357,0,0,0,2.853,1.268,1.636,1.636,0,0,0,1.249-.428,1.115,1.115,0,0,0,.317-.783.972.972,0,0,0-.355-.746,4.473,4.473,0,0,0-1.6-.653l-.839-.261a4.057,4.057,0,0,1-1.79-1.007,3.127,3.127,0,0,1-.709-2.2,4.066,4.066,0,0,1,1.137-3,4.384,4.384,0,0,1,3.188-1.175,8.737,8.737,0,0,1,3.841,1.007l-1.286,2.517a3.278,3.278,0,0,0-2.126-.839,1.548,1.548,0,0,0-1.062.373.922.922,0,0,0-.317.671.83.83,0,0,0,.168.559,2.041,2.041,0,0,0,1.082.56l.988.3a4.74,4.74,0,0,1,2.256,1.23,2.936,2.936,0,0,1,.8,2.219,4.213,4.213,0,0,1-1.175,3.132,4.82,4.82,0,0,1-3.673,1.268,6.652,6.652,0,0,1-2.442-.41,8.676,8.676,0,0,1-1.883-.988Z" transform="translate(-21.331)" fill="#161615" /><path d="M213.359,218.359v9.694h5.086v2.741h-8.311V218.359Z" transform="translate(-33.344 -0.183)" fill="#161615" /><path d="M236.418,228.706h-4.512l-.839,2.088h-3.412l4.773-12.435h3.523l4.679,12.435h-3.449Zm-.858-2.461-1.4-4.027-1.361,4.027Z" transform="translate(-40.278 -0.183)" fill="#161615" /><path d="M256.173,218.359v7.364a2.515,2.515,0,0,0,.634,1.92,2.291,2.291,0,0,0,3.021.056,2.724,2.724,0,0,0,.727-2.256v-7.084h3.225V225.5a5.049,5.049,0,0,1-1.4,4.027,5.37,5.37,0,0,1-4.1,1.548,5.554,5.554,0,0,1-4.12-1.491,5.8,5.8,0,0,1-1.212-4.083v-7.141Z" transform="translate(-50.288 -0.183)" fill="#161615" /><path d="M283,223.563h6.413c0,2.461-.5,4.214-2,5.593a6.068,6.068,0,0,1-4.381,1.566,6.421,6.421,0,0,1-4.773-1.845,6.267,6.267,0,0,1-1.79-4.493,6.483,6.483,0,0,1,1.864-4.661,7.229,7.229,0,0,1,8.184-.987,6.086,6.086,0,0,1,2.218,2.554l-3.076,1.268a3.045,3.045,0,0,0-.894-1.249,2.61,2.61,0,0,0-1.734-.615,3,3,0,0,0-2.126.857,4.2,4.2,0,0,0-1.081,2.853,3.892,3.892,0,0,0,.988,2.685,2.941,2.941,0,0,0,2.275.951,2.666,2.666,0,0,0,1.79-.578,2.214,2.214,0,0,0,.764-1.38H283Z" transform="translate(-59.6)" fill="#161615" /><path d="M309.021,223.563h6.413c0,2.461-.5,4.214-2,5.593a6.067,6.067,0,0,1-4.381,1.566,6.421,6.421,0,0,1-4.772-1.845,6.267,6.267,0,0,1-1.79-4.493,6.483,6.483,0,0,1,1.864-4.661,7.229,7.229,0,0,1,8.184-.987,6.09,6.09,0,0,1,2.218,2.554l-3.076,1.268a3.045,3.045,0,0,0-.894-1.249,2.61,2.61,0,0,0-1.734-.615,3,3,0,0,0-2.125.857,4.2,4.2,0,0,0-1.081,2.853,3.892,3.892,0,0,0,.988,2.685,2.94,2.94,0,0,0,2.274.951,2.664,2.664,0,0,0,1.79-.578,2.217,2.217,0,0,0,.764-1.38h-2.647Z" transform="translate(-69.897)" fill="#161615" /><path d="M335.442,228.706h-4.511l-.839,2.088H326.68l4.772-12.435h3.523l4.679,12.435h-3.448Zm-.857-2.461-1.4-4.027-1.361,4.027Z" transform="translate(-79.468 -0.183)" fill="#161615" /></g></svg>
            <title id="title">Luis Laugga</title>
          </Link>
          <ul className={menuButtonArea}>
            <li className={menuButtonItem}>
              <button className={menuButton} onClick={() => this.toggleMenu()}>
                <div className={iconContainer}>  
                  <div className={this.state.menuOpen ? closeIcon : menuIcon}>
                    <span className={iconFirstLine}></span>
                    <span className={iconSecondLine}></span>
                  </div>
                </div>
              </button>
            </li>
          </ul>
        </header>
        <Menu onChange={this.handleMenuChange} ref={el => (this.childMenu = el)} page={this.props.page} />
      </>
    )
  }

  toggleMenu() {
    if (this.state.menuOpen) {
      this.childMenu.close()
    } else {
      this.childMenu.open()
    }
  }
}

Header.propTypes = {
  page: PropTypes.string,
}

Header.defaultProps = {
  page: ``,
}

export default Header
